import en from './en';
import fr from './fr';
import es from './es';

export default {
    es: {
        message: es,
    },
    en: {
        message: en
    },
    fr: {
        message: fr
    }
}